import { BaseComponent } from '../../../../components/BaseComponent';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { HBox, VBox } from '../../../../components/Box';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';
import { IsOpen, Times } from '../../../../components/Icon';
import { Cell, List, Row } from '../../../../components/List';
import { Loader } from '../../../../components/Loader';
import { ExportInExcelModalBase } from './ExportInExcelModalBase';
import { MainModal } from './MainModal';
import { AddDocumentModal } from './AddDocumentModal';
import { ExtraCostsModal } from './ExtraCostsModal';
import { AddMultiVehiclesToOrder } from './AddMultiVehiclesToOrder';
import { removeVehicleFromBulkActionsList, removeAllVehicleFromBulkActionsList } from '../../actions';
import { selectWork } from '../../../Api/selectors';
import { LAYOUT_BREAK_SMALL } from '../../../../containers/App/constants';
import { REQUEST_ADD_DOCUMENT } from '../../../Users/constants';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { PrintCMRModal } from './PrintCMRModal';
import { TransportInBulkAction } from './KanbanBulkActions/TransportInBulkAction';

import { selectVehicleBulkActionsKanbanTaskName } from '../../selectors';
import { TransportOutBulkAction } from './KanbanBulkActions/TransportOutBulkAction';
import { TransportInPlannedBulkAction } from './KanbanBulkActions/TransportInPlannedBulkAction';
import { TransportOutPlannedBulkAction } from './KanbanBulkActions/TransportOutPlannedBulkAction';
import { IDWE_transport_in_nl_expected_BulkAction } from './KanbanBulkActions/IDWE_Transport_in_nl_expected_BulkAction';
import { Transport_1_nl_in_BulkAction } from './KanbanBulkActions/Transport_1_nl_in_BulkAction';
import { IDWE_transport_in_DLA24_BulkAction } from './KanbanBulkActions/IDWE_transport_in_DLA24_BulkAction';
import { IDWE_transport_nl_out_combined_BulkAction } from './KanbanBulkActions/IDWE_transport_nl_out_combined_BulkAction';
import { IDWE_transport_nl_individual_BulkAction } from './KanbanBulkActions/IDWE_transport_nl_individual_BulkAction';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import styles from './BulkActionsCard.module.css';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { CreateTransportOrderModal } from '../../../TransportOrders/components/createTransportOrder/CreateTransportOrderModal';

const Container = styled.div`
  position: fixed;
  display: flex;
  z-index: 9999;

  right: 2%;
  bottom: 0;
  justify-content: center;
  align-items: center;
  overflow: auto;

  .header {
    background-color: ${COLOR_PRIMARY_1};
    color: white;
    width: auto;
    height: 60px;
    margin: -12px 0 0 0;
    padding: 0px 24px;
    .button {
      margin: 0;
      text-align: right;
      width: 40px;
    }
  }

  .times {
    display: flex;
    padding: 0 8px;
  }

  .button {
    width: 200px;
  }

  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    right: 0;
    overflow: auto;
    width: 100%;
    .header {
      background-color: ${COLOR_PRIMARY_1};
      color: white;
      width: 100%;
      margin: 0;
      padding: 6px 24px;
      .button {
        margin: 0;
        text-align: right;
        width: 40px;
      }
    }

    .modal-footer-button {
      margin: 0;
      display: flex;
      height: 70px;
      min-width: 50%;

      .list-result-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        margin: 5px;
        background-color: #fff;
        color: ${COLOR_PRIMARY_1};
      }
    }
  }
`;

const Inner = styled.div`
  background-color: rgba(255, 255, 255, 1);
  border-radius: 6px;
  padding: 12px 0 0 0;
  min-width: 380px;
  width: ${props => (props?.wider ? '60%' : props?.mediumWide ? '40%' : 'auto')};
  visibility: ${props => (props.isShowMainModal ? 'hidden' : '')};
  max-width: 100%;
  max-height: 90%;
  overflow: auto;

  @media (max-width: ${LAYOUT_BREAK_SMALL}px) {
    min-width: 300px;
    width: 100%;
    height: ${props => (props.isOpen ? '85vh' : '')};
    padding-top: 0;

    .footer-controls {
      position: fixed;
      bottom: 0;
    }
  }

  .model-info {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 330px;
  }

  .bulk-action-list {
    padding: 12px;
    overflow: auto;
    max-height: 200px;
    font-size: 14px;

    @media (max-width: 768px) {
      min-height: 80vh;
      max-height: auto;
      overflow: none;
    }
  }

  .icon-block {
    display: flex;
    align-items: center;
    justify-contect: center;
    cursor: pointer;
    width: 25px;
    height: 25px;
    background-color: #d50046;
    color: #fff;
  }
`;

const TopControls = styled.div`
  text-align: right;
  margin-right: ${props => (props.innerWidth <= 768 ? '50px' : '20px')};
  z-index: '10';
`;

const Title = styled.div`
  font-weight: 600;
`;

// IMPORTANT TO ADD NEW MODALS HERE WITH FALSE VALUE
const INITIAL_MODALS_STATE = {
  isShowExcelModal: false,
  isShowMainModal: false,
  isShowDocumentModal: false,
  isShowExtraCostsModal: false,
  isShowCreateTransportModal: false,
  isShowAddToOrder: false,
  isShowPrintCMRModal: false,
  isShowTransport_in_eu: false,
  isShowTransport_out_eu: false,
  isShowTransport_eu_in_planned: false,
  isShowTransport_eu_out_planned: false,
  isShowIDWE_transport_in_nl_expected: false,
  isShowIDWE_transport_in_DLA24: false,
  isShowTransport_1_nl_in: false,
  isShowIDWE_transport_nl_out_combined: false,
  isShowIDWE_transport_nl_individual: false,
};

const STATE = {
  isOpen: false,
  loading: false,
  isShowMainModal: false,
};

class BulkActionsCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  reset() {
    this.setState({
      ...INITIAL_MODALS_STATE,
    });
  }

  get vehicleIds() {
    return this.props.bulkActionsList?.map(vehicle => vehicle?.id);
  }

  get outgoingToAddressIds() {
    return this.props.bulkActionsList?.map(vehicle => vehicle?.transport_outgoing_to_address_id);
  }

  get outgoingToCompanyId() {
    return this.props.bulkActionsList[0]?.transport_outgoing_to_company_id;
  }

  getAction(action) {
    switch (action) {
      case 'showDocumentModal':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowDocumentModal: true,
        });
      case 'Transport_in_eu_planned_1':
      case 'Transport_in_eu_planned_2':
      case 'Transport_in_eu_planned_3':
      case 'Transport_in_eu_planned_4':
      case 'Transport_in_eu_planned_5':
      case 'Transport_in_eu_planned_6':
      case 'Transport_in_eu_planned_7':
      case 'Transport_in_eu_planned_8':
      case 'Transport_in_eu_planned_9':
      case 'Transport_in_eu_planned_10':
        this.setState({
          ...INITIAL_MODALS_STATE,
          isShowTransport_eu_in_planned: true,
        });

      case 'Transport_out_eu_planned_1':
      case 'Transport_out_eu_planned_2':
      case 'Transport_out_eu_planned_3':
      case 'Transport_out_eu_planned_4':
      case 'Transport_out_eu_planned_5':
      case 'Transport_out_eu_planned_6':
      case 'Transport_out_eu_planned_7':
      case 'Transport_out_eu_planned_8':
      case 'Transport_out_eu_planned_9':
      case 'Transport_out_eu_planned_10':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowTransport_eu_out_planned: true,
        });

      case 'showExtraCostsModal':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowExtraCostsModal: true,
        });
      case 'showExcelModal':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowExcelModal: true,
        });
      case 'showAddToOrderModal':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowAddToOrder: true,
        });
      case 'showPrintCMRModal':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowPrintCMRModal: true,
        });
      case 'showCreateTransportModal':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowCreateTransportModal: true,
        });
      case 'Transport_in_eu':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowTransport_in_eu: true,
        });
      case 'Transport_out_eu':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowTransport_out_eu: true,
        });
      case 'IDWE_transport_in_nl_expected':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowIDWE_transport_in_nl_expected: true,
        });
      case 'Transport_1_nl_in':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowTransport_1_nl_in: true,
        });
      case 'IDWE_transport_in_DLA24':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowIDWE_transport_in_DLA24: true,
        });
      case 'IDWE_transport_nl_out_combined':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowIDWE_transport_nl_out_combined: true,
        });
      case 'IDWE_transport_nl_individual':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowIDWE_transport_nl_individual: true,
        });

      case 'close':
        return this.setState({
          ...INITIAL_MODALS_STATE,
        });
    }
  }

  renderWarningModal() {
    if (!this.state.isShowWarningModal) return null;
    return (
      <ModalComponent
        onClose={() => this.setState({ isShowWarningModal: false })}
        title={this.lbl('company.modal.delete.confirm.title')}
      >
        <div className={styles.buttonContainer}>
          <ButtonComponent style="ButtonSoftEdit" onClick={() => this.props.removeAllVehicleFromBulkActionsList(res => {})}>
            {this.lbl('confirm')}
          </ButtonComponent>

          <ButtonComponent style="ButtonSoftDelete" onClick={() => this.setState({ isShowWarningModal: false })}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    return (
      <Container onClick={this.props.onClose} className="modal-container">
        {this.renderWarningModal()}
        {this.state.isShowDocumentModal && (
          <AddDocumentModal vehicleIds={this.vehicleIds} sendAction={action => this.getAction(action)} />
        )}
        {this.state.isShowExtraCostsModal && (
          <ExtraCostsModal vehicleIds={this.vehicleIds} sendAction={action => this.getAction(action)} />
        )}
        {this.state.isShowCreateTransportModal && (
          <CreateTransportOrderModal
            onClose={() => this.getAction('close')}
            sendAction={action => this.getAction(action)}
            vehicleIds={this.vehicleIds}
            from_location={this.props.from_location}
            bulkActionsList={this.props.bulkActionsList}
          />
        )}
        {this.state.isShowExcelModal && (
          <ExportInExcelModalBase
            mobileView={window.innerWidth <= 768}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.state.isShowAddToOrder && (
          <AddMultiVehiclesToOrder
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
            sendAction={action => this.getAction(action)}
          />
        )}
        {this.state.isShowPrintCMRModal && (
          <PrintCMRModal
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
            outgoingToAddressIds={this.outgoingToAddressIds}
            outgoingToCompanyId={this.outgoingToCompanyId}
            sendAction={action => this.getAction(action)}
            paginatedList={this.props.currentPage}
          />
        )}
        {this.state.isShowTransport_in_eu && (
          <TransportInBulkAction
            sendAction={action => this.getAction(action)}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.state.isShowTransport_eu_in_planned && (
          <TransportInPlannedBulkAction
            sendAction={action => this.getAction(action)}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.state.isShowTransport_eu_out_planned && (
          <TransportOutPlannedBulkAction
            sendAction={action => this.getAction(action)}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.state.isShowTransport_out_eu && (
          <TransportOutBulkAction
            sendAction={action => this.getAction(action)}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.state.isShowIDWE_transport_in_nl_expected && (
          <IDWE_transport_in_nl_expected_BulkAction
            sendAction={action => this.getAction(action)}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.state.isShowTransport_1_nl_in && (
          <Transport_1_nl_in_BulkAction
            sendAction={action => this.getAction(action)}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.state.isShowIDWE_transport_in_DLA24 && (
          <IDWE_transport_in_DLA24_BulkAction
            sendAction={action => this.getAction(action)}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.state.isShowIDWE_transport_nl_out_combined && (
          <IDWE_transport_nl_out_combined_BulkAction
            sendAction={action => this.getAction(action)}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.state.isShowIDWE_transport_nl_individual && (
          <IDWE_transport_nl_individual_BulkAction
            sendAction={action => this.getAction(action)}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}

        {this.state.isShowMainModal && <MainModal sendAction={action => this.getAction(action)} />}
        {this.props.work ? (
          <Loader small />
        ) : (
          <Inner
            isShowMainModal={this.state.isShowMainModal}
            isOpen={this.state.isOpen}
            onClick={evt => evt.stopPropagation()}
            className="modal-inner"
            mediumWide={this.props.mediumWide}
            wider={this.props.wider}
          >
            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <HBox className="header" vCenter>
                <Title>{this.lbl('vehicle.overview.excel_card.title')}&nbsp;</Title>
                <TopControls innerWidth={window.innerWidth}>
                  <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                    <IsOpen />
                  </div>
                </TopControls>
              </HBox>
            </div>
            {this.state.isOpen && (
              <div className="bulk-action-list">
                <List>
                  {this.props.bulkActionsList.map(vehicle => (
                    <Row key={vehicle?.id}>
                      <Cell>
                        <VBox>
                          <strong>{vehicle?.regplate}</strong>
                          <span>{vehicle.vin?.substr(-6)}</span>
                        </VBox>
                      </Cell>
                      <Cell>
                        <div style={{ textAlign: 'left' }}>
                          <span style={{ textDecoration: 'none' }}>
                            <strong>
                              {vehicle.brand_name} {vehicle.model_name}
                            </strong>{' '}
                            {vehicle.power ? <>| {vehicle.power} Kw</> : ''}
                          </span>
                          <br />
                          <div className="model-info">{vehicle.model_info}</div>
                        </div>
                      </Cell>
                      <Cell>
                        <div className="icon-block" onClick={() => this.props.removeVehicleFromBulkActionsList(vehicle?.id)}>
                          <Times />
                        </div>
                      </Cell>
                    </Row>
                  ))}
                </List>
              </div>
            )}
            {this.state.isOpen && (
              <HBox className="footer-controls">
                {this.state.loading && <Loader small />}
                <Button
                  className="modal-footer-button"
                  warning
                  onClick={() => {
                    this.setState({ isShowWarningModal: true });
                  }}
                >
                  {this.lbl('vehicle.overview.excel_card.delete_all')}
                </Button>
                <Button className="modal-footer-button" onClick={() => this.setState({ isShowMainModal: true })}>
                  {this.lbl('vehicle.overview.bulk_actions')}
                  {window.innerWidth <= 768 && <p className="list-result-label">{this.props.bulkActionsList?.length}</p>}
                </Button>
              </HBox>
            )}
          </Inner>
        )}
      </Container>
    );
  }
}

BulkActionsCardComp.propTypes = {};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_ADD_DOCUMENT),
    bulkActionTask: selectVehicleBulkActionsKanbanTaskName(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    removeVehicleFromBulkActionsList(vehicleId) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId, ownProps.currentPage || null));
    },
    removeAllVehicleFromBulkActionsList(callback) {
      dispatch(removeAllVehicleFromBulkActionsList(callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const BulkActionsCard = compose(withConnect, withRouter, injectIntl)(BulkActionsCardComp);
